import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"
import _imports_0 from '@/assets/icons/receipt.svg'


const _hoisted_1 = { class: "container" }
const _hoisted_2 = { class: "frame" }
const _hoisted_3 = { class: "frame__inner" }
const _hoisted_4 = { class: "frame__body" }
const _hoisted_5 = { class: "status" }
const _hoisted_6 = { class: "status__inner" }
const _hoisted_7 = {
  key: 0,
  class: "status__item status-success"
}
const _hoisted_8 = { class: "status__icon" }
const _hoisted_9 = { class: "status__title" }
const _hoisted_10 = { class: "status__description" }
const _hoisted_11 = { class: "status__receipt" }
const _hoisted_12 = ["href"]
const _hoisted_13 = { class: "receipt__text" }
const _hoisted_14 = { class: "status__btn" }
const _hoisted_15 = {
  key: 1,
  class: "status__item status-error"
}
const _hoisted_16 = { class: "status__icon" }
const _hoisted_17 = { class: "status__title" }
const _hoisted_18 = { class: "status__description" }
const _hoisted_19 = { class: "status__btn" }
const _hoisted_20 = {
  key: 2,
  class: "status__item status-process"
}
const _hoisted_21 = { class: "status__icon" }
const _hoisted_22 = { class: "process" }
const _hoisted_23 = { class: "status__title" }
const _hoisted_24 = { class: "status__description" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_status_icon = _resolveComponent("status-icon")!
  const _component_ap_button = _resolveComponent("ap-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("div", _hoisted_6, [
              (_ctx.data.status === 'success')
                ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createElementVNode("div", _hoisted_8, [
                      _createVNode(_component_status_icon, {
                        name: 'success',
                        type: _ctx.currentMerchant
                      }, null, 8, ["type"])
                    ]),
                    _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.statusDefaultTitle[_ctx.data.status] || 'Успешный перевод'), 1),
                    _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.data.failure_description || _ctx.statusDefaultDescription[_ctx.data.status] || 'Платеж проведен'), 1),
                    _createElementVNode("div", _hoisted_11, [
                      (_ctx.data.receipt_url)
                        ? (_openBlock(), _createElementBlock("a", {
                            key: 0,
                            class: "receipt",
                            href: _ctx.data.receipt_url,
                            target: "_blank"
                          }, [
                            _createElementVNode("div", _hoisted_13, _toDisplayString(_ctx.$t('get_check')), 1),
                            _cache[0] || (_cache[0] = _createElementVNode("img", {
                              class: "receipt__icon",
                              src: _imports_0,
                              alt: "receipt__icon"
                            }, null, -1))
                          ], 8, _hoisted_12))
                        : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("div", _hoisted_14, [
                      _createVNode(_component_ap_button, {
                        type: "primary",
                        onClick: _ctx.toMain
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(_ctx.$t('to_main')), 1)
                        ]),
                        _: 1
                      }, 8, ["onClick"])
                    ])
                  ]))
                : (_ctx.data.status === 'error')
                  ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                      _createElementVNode("div", _hoisted_16, [
                        _createVNode(_component_status_icon, {
                          name: 'error',
                          type: _ctx.currentMerchant
                        }, null, 8, ["type"])
                      ]),
                      _createElementVNode("div", _hoisted_17, _toDisplayString(_ctx.statusDefaultTitle[_ctx.data.status]), 1),
                      _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.data.failure_description || _ctx.statusDefaultDescription[_ctx.data.status]), 1),
                      _createElementVNode("div", _hoisted_19, [
                        _createVNode(_component_ap_button, {
                          type: "primary",
                          onClick: _ctx.toMain
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(_ctx.$t('try_again')), 1)
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ])
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      _createElementVNode("div", _hoisted_21, [
                        _createElementVNode("div", _hoisted_22, [
                          _createVNode(_component_status_icon, {
                            name: 'process',
                            class: "process__icon"
                          })
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_23, _toDisplayString(_ctx.statusDefaultTitle[_ctx.data.status] || _ctx.statusDefaultTitle['process']), 1),
                      _createElementVNode("div", _hoisted_24, _toDisplayString(_ctx.data.failure_description || _ctx.statusDefaultDescription[_ctx.data.status] || _ctx.statusDefaultDescription['process']), 1)
                    ]))
            ])
          ])
        ])
      ])
    ])
  ]))
}